import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/mollu_coconutcorn.png'
import _imports_1 from '@/assets/images/mdi-content-copy.svg'


const _hoisted_1 = {
  key: 0,
  class: "chat-balloon"
}
const _hoisted_2 = { class: "chat-balloon-content" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "profile-image",
  src: _imports_0,
  alt: "아로나 프로필 이미지"
}, null, -1)
const _hoisted_5 = { class: "chat-balloon-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "profile-name" }, "아로?나", -1)
const _hoisted_7 = { class: "chat-balloon" }
const _hoisted_8 = { class: "chat-balloon-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "몰?루화된 문장 복사"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-item", { user: _ctx.fromUser, mollu: !_ctx.fromUser }])
  }, [
    (_ctx.fromUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.chatData.content), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.chatData.content), 1),
              _createElementVNode("button", {
                class: "chat-balloon-copy-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.chatData.content)))
              }, _hoisted_10)
            ])
          ])
        ]))
  ], 2))
}